import { STORAGE_MODE_BUTTON_VISIBLE_KEY, STORAGE_MODE_ENABLED_KEY } from '../config/storage-keys';
import { initI18n } from '../utils/i18n';
import useGlobalContext from './useGlobalContext';

export const useTranslationKeyMode = () => {
  const { get, set } = useGlobalContext();

  const isTranslationKeyModeVisible = get('isTranslationKeyModeVisible');
  const setTranslationKeyModeVisible = (visible: boolean) => {
    if (visible) {
      localStorage.setItem(STORAGE_MODE_BUTTON_VISIBLE_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_MODE_BUTTON_VISIBLE_KEY);
    }

    set({ isTranslationKeyModeVisible: visible });
  };

  const isTranslationKeyModeEnabled = get('isTranslationKeyModeEnabled');
  const setTranslationKeyModeEnabled = (enabled: boolean) => {
    if (enabled) {
      localStorage.setItem(STORAGE_MODE_ENABLED_KEY, 'true');
    } else {
      localStorage.removeItem(STORAGE_MODE_ENABLED_KEY);
    }
    initI18n();

    set({ isTranslationKeyModeEnabled: enabled });
  };

  return {
    isTranslationKeyModeEnabled,
    isTranslationKeyModeVisible,
    setTranslationKeyModeVisible,
    setTranslationKeyModeEnabled,
  };
};
